import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { QuoteIcon, ShieldCheckIcon, RotateCcwIcon } from 'lucide-react';
export function TestimonialSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-12 sm:py-16 px-4 sm:px-6" style={{
    background: 'linear-gradient(180deg, #0D1F3C 0%, #1B3A6B 50%, #0D1F3C 100%)'
  }} data-id="element-118">
      <div className="max-w-3xl mx-auto" data-id="element-119">
        {/* Testimonial */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="relative p-8 md:p-10 rounded-2xl mb-12" style={{
        background: 'linear-gradient(135deg, rgba(10,22,40,0.9) 0%, rgba(27,58,107,0.5) 100%)',
        border: '2px solid rgba(201,168,76,0.4)'
      }} data-id="element-120">
          {/* Large quote mark */}
          <div className="absolute -top-5 left-8" data-id="element-121">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{
            background: 'linear-gradient(135deg, #C9A84C, #F0D080)'
          }} data-id="element-122">
              <QuoteIcon size={20} className="text-navy-deep" data-id="element-123" />
            </div>
          </div>

          <blockquote className="font-lato text-xl md:text-2xl leading-relaxed italic mb-6 pt-4" style={{
          color: '#FFF8E7'
        }} data-id="element-124">
            "Sentía mucha angustia por la inseguridad en mi colonia. Empecé a
            usar las oraciones de sellamiento en las puertas de mi casa y ahora
            mis hijos y yo dormimos con una paz que no puedo explicar. Es la
            mejor inversión que he hecho."
          </blockquote>

          <div className="flex items-center gap-4" data-id="element-125">
            <div className="w-12 h-12 rounded-full flex items-center justify-center font-cinzel font-bold text-lg" style={{
            background: 'linear-gradient(135deg, #C9A84C, #F0D080)',
            color: '#0A1628'
          }} data-id="element-126">
              E
            </div>
            <div data-id="element-127">
              <p className="font-cinzel font-bold text-gold-light" data-id="element-128">Elena R.</p>
              <p className="font-lato text-sm" style={{
              color: 'rgba(255,248,231,0.6)'
            }} data-id="element-129">
                Ciudad de México
              </p>
            </div>
          </div>
        </motion.div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="rounded-2xl p-8 md:p-10 text-center" style={{
        background: 'linear-gradient(135deg, rgba(10,22,40,0.95) 0%, rgba(27,58,107,0.4) 100%)',
        border: '2px solid rgba(201,168,76,0.5)'
      }} data-id="element-130">
          <div className="flex justify-center mb-5" data-id="element-131">
            <div className="w-20 h-20 rounded-full flex items-center justify-center" style={{
            background: 'linear-gradient(135deg, rgba(201,168,76,0.2) 0%, rgba(240,208,128,0.1) 100%)',
            border: '3px solid #C9A84C'
          }} data-id="element-132">
              <ShieldCheckIcon size={40} className="text-gold-warm" data-id="element-133" />
            </div>
          </div>

          <h3 className="font-cinzel font-bold text-2xl md:text-3xl mb-4 text-gold-light" data-id="element-134">
            GARANTÍA DE PAZ
          </h3>
          <div className="divider-gold mx-auto mb-6" style={{
          width: '120px'
        }} data-id="element-135" />

          <p className="font-lato text-lg leading-relaxed mb-4" style={{
          color: 'rgba(255,248,231,0.9)'
        }} data-id="element-136">
            Si en <strong className="text-gold-light" data-id="element-137">7 días</strong> no sientes
            que este manual ha traído más tranquilidad y fe a tu vida, te
            devolvemos el{' '}
            <strong className="text-gold-light" data-id="element-138">100% de tu dinero.</strong>
          </p>
          <p className="font-lato text-base" style={{
          color: 'rgba(255,248,231,0.7)'
        }} data-id="element-139">
            Sin preguntas. Tu paz es nuestra prioridad.
          </p>

          <div className="flex items-center justify-center gap-2 mt-6" data-id="element-140">
            <RotateCcwIcon size={18} className="text-gold-warm" data-id="element-141" />
            <span className="font-cinzel text-sm text-gold-warm tracking-wide" data-id="element-142">
              GARANTÍA DE 7 DÍAS
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}